module.exports = __webpack_public_path__ + "img/photo3_7.9cd28215.jpg";